import React, { useState } from "react";
import { FORM_ERROR } from "final-form";
import { Form as FinalForm, Field } from "react-final-form";
import { recoverValidation } from "../../../../app/store/actions/recoverActions";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthLessThan,
  hasLengthBetween,
  // hasLengthGreaterThan,
  isRequiredIf,
} from "revalidate";
import { isValidEmail } from "../../../../app/util/revalidateUtils";
import { Form, Button, Grid, GridColumn, Header } from "semantic-ui-react";
import TextInput from "../../../../app/common/form/TextInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import DateInput from "../../../../app/common/form/DateInput";
import { connect } from "react-redux";
import {
  LONGITUD_MAXIMA_CELULAR,
  // LONGITUD_MAXIMA_CUENTA_CREDITO,
  LONGITUD_MAXIMA_CORREO,
  // LONGITUD_MINIMA_CUENTA_CREDITO,
} from "../../../../app/infrastructure/appConstants";
import { normalizeNumero } from "../../../../app/util/finalFormUtils";
import RecoverFormHeader from "./header/RecoverFormHeader";
import RecoverFormStep from "./step/RecoverFormStep";
import RecoverCancel from "./RecoverCancel";
import { tipoDocumentoOptions } from "../../../../app/config/data/options";
import {
  CODIGO_TIPO_DOCUMENTO_RUC,
  CODIGO_TIPO_DOCUMENTO_DNI,
  LONGITUD_TIPO_DOCUMENTO_DNI,
} from "../../../../app/infrastructure/appConstants";
import {
  normalizeNumeroDocumentoIdentidad,
  getLengthNumeroDocumentoIdentidad,
} from "../../../../app/util/finalFormUtils";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import PropTypes from "prop-types";

const mapState = (state) => ({
  currentCustomer: state.recoverUser.currentCustomer,
  fase: state.recoverUser.fase,
});

const actions = {
  recoverValidation,
};

const RecoverValidationForm = ({ currentCustomer, recoverValidation }) => {
  const [
    identificacionRepresentanteLegal,
    setidentificacionRepresentanteLegal,
  ] = useState(false);

  const [tipoDocumentoCliente, setTipoDocumentoCliente] = useState(
    CODIGO_TIPO_DOCUMENTO_DNI
  );

  const [tipoDocumentoRepresentante, setTipoDocumentoRepresentante] = useState(
    CODIGO_TIPO_DOCUMENTO_DNI
  );

  const [
    lengthNumeroDocumentoCliente,
    setLengthNumeroDocumentoCliente,
  ] = useState(LONGITUD_TIPO_DOCUMENTO_DNI);

  const [
    lengthNumeroDocumentoRepresentante,
    setLengthNumeroDocumentoRepresentante,
  ] = useState(LONGITUD_TIPO_DOCUMENTO_DNI);

  const onChangeTipoDocumentoCliente = (value) => {
    setTipoDocumentoCliente(value);
    // Si tipo documento de cliente es RUC se habilita campos de representante legal
    setidentificacionRepresentanteLegal(
      value && value === CODIGO_TIPO_DOCUMENTO_RUC
    );
    //Actualizando longitud
    setLengthNumeroDocumentoCliente(getLengthNumeroDocumentoIdentidad(value));
  };

  const onChangeTipoDocumentoRepresentante = (value) => {
    setTipoDocumentoRepresentante(value);
    //Actualizando longitud
    setLengthNumeroDocumentoRepresentante(
      getLengthNumeroDocumentoIdentidad(value)
    );
  };

  const validate = combineValidators({
    tipoDocumentoCliente: composeValidators(
      isRequired({ message: "Tipo de documento es requerido" })
    )(),
    numeroDocumentoCliente: composeValidators(
      isRequired({ message: "Número de documento es requerido" }),
      hasLengthBetween(
        lengthNumeroDocumentoCliente,
        lengthNumeroDocumentoCliente
      )({
        message: "Número de documento del cliente no válido",
      })
    )(),
    tipoDocumentoRepresentante: composeValidators(
      isRequiredIf(
        (values) =>
          values && values.tipoDocumentoCliente === CODIGO_TIPO_DOCUMENTO_RUC
      )({
        message: "Tipo de documento del representante legal es requerido",
      })
    )(),
    numeroDocumentoRepresentante: composeValidators(
      isRequiredIf(
        (values) =>
          values && values.tipoDocumentoCliente === CODIGO_TIPO_DOCUMENTO_RUC
      )({
        message: "Número de documento del representante legal es requerido",
      }),
      hasLengthBetween(
        lengthNumeroDocumentoRepresentante,
        lengthNumeroDocumentoRepresentante
      )({
        message: "Número de documento del representante no es válido",
      })
    )(),
    fechaNacimiento: composeValidators(
      isRequired({ message: "Fecha de nacimiento es requerido" })
    )(),
    celular: composeValidators(
      isRequired({ message: "Celular es requerido" }),
      hasLengthBetween(
        LONGITUD_MAXIMA_CELULAR,
        LONGITUD_MAXIMA_CELULAR
      )({
        message: "Celular no válido",
      })
    )(),
    correoElectronico: composeValidators(
      isRequired({ message: "Correo electrónico es requerido" }),
      isValidEmail,
      hasLengthLessThan(LONGITUD_MAXIMA_CORREO + 1)({
        message: "Correo electrónico no válido",
      })
    )(),
    // numeroCuentaCredito: composeValidators(
    //   isRequired({ message: "Número de cuenta o crédito es requerido" }),
    //   hasLengthGreaterThan(LONGITUD_MINIMA_CUENTA_CREDITO)({
    //     message: "Ingresa el menos 10 dígitos",
    //   })
    // )(),
  });

  return (
    <FinalForm
      onSubmit={(values) =>
        recoverValidation({ ...currentCustomer, ...values }).catch((error) => ({
          [FORM_ERROR]: error,
        }))
      }
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit,
      }) => (
        <Form onSubmit={handleSubmit} error>
          <br />
          <RecoverFormHeader />
          <RecoverFormStep />
          <Header textAlign="center">
            <Header.Subheader>
              Ingresa los siguientes datos para validar que eres tú
            </Header.Subheader>
          </Header>
          <br />
          <Field
            name="tipoDocumentoCliente"
            component={SelectedInput}
            placeholder="Tipo de documento"
            options={tipoDocumentoOptions}
            handleOnChange={onChangeTipoDocumentoCliente}
          />
          <Field
            name="numeroDocumentoCliente"
            component={TextInput}
            placeholder="Número de documento"
            parse={(value) =>
              normalizeNumeroDocumentoIdentidad(value, tipoDocumentoCliente)
            }
            maxLength={lengthNumeroDocumentoCliente}
          />

          {identificacionRepresentanteLegal && (
            <>
              <Header as="h5" color="blue" textAlign="left">
                Representante legal
              </Header>
              <Field
                name="tipoDocumentoRepresentante"
                component={SelectedInput}
                placeholder="Tipo de documento"
                options={tipoDocumentoOptions}
                handleOnChange={onChangeTipoDocumentoRepresentante}
              />
              <Field
                name="numeroDocumentoRepresentante"
                component={TextInput}
                placeholder="Número de documento"
                parse={(value) =>
                  normalizeNumeroDocumentoIdentidad(
                    value,
                    tipoDocumentoRepresentante
                  )
                }
                maxLength={lengthNumeroDocumentoRepresentante}
              />
            </>
          )}

          <Field
            name="fechaNacimiento"
            component={DateInput}
            placeholder="Fecha de nacimiento"
          />

          <Field
            name="correoElectronico"
            component={TextInput}
            placeholder="Correo electrónico"
            maxLength={LONGITUD_MAXIMA_CORREO}
          />

          <Field
            name="celular"
            component={TextInput}
            placeholder="Celular"
            maxLength={LONGITUD_MAXIMA_CELULAR}
            parse={normalizeNumero}
          />

          {/* <Field
            name="numeroCuentaCredito"
            component={TextInput}
            placeholder="Número de cuenta o crédito en Prymera"
            maxLength={LONGITUD_MAXIMA_CUENTA_CREDITO}
            parse={normalizeNumero}
          /> */}

          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage error={submitError} />
          )}
          <br />
          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <GridColumn>
                <RecoverCancel />
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  size="large"
                  loading={submitting}
                  color="yellow"
                  content="Aceptar"
                />
              </GridColumn>
            </Grid.Row>
          </Grid>
        </Form>
      )}
    />
  );
};

RecoverValidationForm.propTypes = {
  currentCustomer: PropTypes.object,
  recoverValidation: PropTypes.func.isRequired,
};

export default connect(mapState, actions)(RecoverValidationForm);
